import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(//renders the application on the root id
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


